import { render, staticRenderFns } from "./InformationSystemListRow.vue?vue&type=template&id=10d51958"
import script from "./InformationSystemListRow.vue?vue&type=script&lang=js"
export * from "./InformationSystemListRow.vue?vue&type=script&lang=js"
import style0 from "./InformationSystemListRow.vue?vue&type=style&index=0&id=10d51958&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports